import React from "react";
import { Link } from "react-router-dom";
import PronounceButton from "@/components/PronounceButton";
import { Flame } from "lucide-react";

const BG_ROTATION = ["bg-lime", "bg-peach", "bg-mint", "bg-sky", "bg-lilac", "bg-altsoft"];

export default function SlangCard({ slang, index = 0, compact = false }) {
  const bg = BG_ROTATION[index % BG_ROTATION.length];
  return (
    <Link
      to={`/slang/${slang.id}`}
      data-testid={`slang-card-${slang.word.toLowerCase().replace(/\s+/g, "-")}`}
      className={`block ${bg} brutal brutal-hover p-5 sm:p-6 pop-in relative no-underline text-ink`}
      style={{ animationDelay: `${(index % 12) * 30}ms` }}
    >
      {slang.trending && (
        <span data-testid="trending-badge" className="absolute -top-3 -right-3 bg-hot text-white brutal-sm px-2 py-1 font-mono-tag text-[10px] uppercase rotate-2 flex items-center gap-1">
          <Flame className="h-3 w-3" strokeWidth={3} /> Trending
        </span>
      )}
      <div className="flex items-start justify-between gap-3 mb-2">
        <h3 className="font-display text-2xl sm:text-3xl leading-none">{slang.word}</h3>
        <PronounceButton text={slang.word} testId={`pronounce-${slang.id}`} size="sm" />
      </div>
      <p className="font-mono-tag text-[10px] uppercase mb-3 inline-block bg-white brutal-sm px-2 py-0.5">{slang.category}</p>
      {!compact && (
        <p className="text-sm sm:text-base leading-snug mb-3">{slang.meaning}</p>
      )}
      {!compact && slang.example && (
        <p className="font-hand text-lg leading-tight border-t-2 border-black pt-2">"{slang.example}"</p>
      )}
    </Link>
  );
}
